import { render, staticRenderFns } from "./PageStyle.vue?vue&type=template&id=226681c2&scoped=true&"
import script from "./PageStyle.vue?vue&type=script&lang=ts&"
export * from "./PageStyle.vue?vue&type=script&lang=ts&"
import style0 from "./PageStyle.vue?vue&type=style&index=0&id=226681c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226681c2",
  null
  
)

export default component.exports